function helpdesk() {

  if( !! $("#searchstring").length) {
  
    //var jsonSource = 'https://help.ultramusicfestival.com/customer/portal/articles/autocomplete?term='+clickedText+'*';
    //var jsonSource = 'https://help.ultramusicfestival.com/api/v2/articles/search?text=what%20time%20is%20the%20festival';
    //http://stackoverflow.com/questions/23305000/javascript-fuzzy-search-that-makes-sense
    //http://lunrjs.com/
    var jsonResults = [];
    var jsonSource = site_url+'/helpqs.json'

    // Build the initial list
    $.get( jsonSource , function() {})
    .done(function(data) {
      $.each( data['_embedded']['entries'], function( key, val ) {
         if (val.in_support_center == true) {

          var thedate = val.updated_at;
          var theyear = thedate.slice(0,4);
          var themonth = thedate.slice(5,7);
          var theday = thedate.slice(8,10);
          var fDate = `${themonth} / ${theday} / ${theyear}`;

          jsonResults.push({
            url: val.public_url,
            subject: val.subject,
            last_updated: fDate,
            body: val.body
          });
        }
      })
    })
    .fail(function(error) { log(error); } )
    .always(function() { buildList(jsonResults); })


    // Bind Searches
    $(document).on('keyup', '.qa-search', function(e) {
      var theval = $(this).val();
      $('#searchstring').val(theval);
      query = $('#searchstring').val();
      if (query.length > 1) {
        buildList(filterList(jsonResults, query));
      }
    });
    $(document).on('blur', '.qa-search', function(e) {
      var theval = $(this).val();
      $('#searchstring').val(theval)
      query = $('#searchstring').val();
      if (query.length > 1) {
        buildList(filterList(jsonResults, query));
      }
    });


    function buildList(data) {
      var output = '';
      if ( !data.length ) {
        output += `<li class="nonefound"><p style="padding-top:10px; display:block;">${__('Sorry, no suggestions available.', 'ultra-2015')}</p></li>`;
      } else {
        $.each( data, function( key, val ) {
          output += `<li class="qa"><a href="${val.url}" target="_blank">${val.subject}</a> <div class="lbreak3"></div><div class="answer">${val.body}<br><br></div></li>`;
        })
      }
      $('div.qas ul').html(output);
    }


    function filterList(data,query) {

      if (query == '') { return data; }

      var get_bigrams, j, len, name, obj, query, relevance, results, string_similarity;

      get_bigrams = function(string) {
        var i, j, ref, s, v;
        s = string.toLowerCase();
        v = new Array(s.length - 1);
        for (i = j = 0, ref = v.length; j <= ref; i = j += 1) {
          v[i] = s.slice(i, i + 2);
        }
        return v;
      };

      string_similarity = function(str1, str2) {
        var hit_count, j, k, len, len1, pairs1, pairs2, union, x, y;
        if (str1.length > 0 && str2.length > 0) {
          pairs1 = get_bigrams(str1);
          pairs2 = get_bigrams(str2);
          union = pairs1.length + pairs2.length;
          hit_count = 0;
          for (j = 0, len = pairs1.length; j < len; j++) {
            x = pairs1[j];
            for (k = 0, len1 = pairs2.length; k < len1; k++) {
              y = pairs2[k];
              if (x === y) {
                hit_count++;
              }
            }
          }
          if (hit_count > 0) {
            return (2.0 * hit_count) / union;
          }
        }
        return 0.0;
      };

      results = [];

      for (j = 0, len = data.length; j < len; j++) {

        var relevance = string_similarity(query, `${data[j].subject} ${data[j].body}`);
        if ( relevance > 0.001) {
          results.push({
            subject: data[j].subject,
            body: data[j].body,
            url: data[j].url,
            last_updated: data[j].last_updated,
            relevance: relevance
          });
        }
      }

      results.sort(function(a, b) {
          return -(a.relevance - b.relevance);
      });
      results = results.slice(0,10);

      //log(results);
      return results;

    }


    // Action Button
    $(document).on('mousedown', '.qas a', function(e){

      e.preventDefault();
      var answer = $(this).parent().find('div.answer').html();
      answer = `<h1>Answer:</h1><a class="btn-close"></a><div class="answer-text custom-scroller">${answer}<div class="clear"></div><div class="lbreak2"></div><p class="answer-footer"><em>Still have a question? <strong><a class="btn-goemail"><span class="fas fa-envelope"></span> Email Us</a></strong></em></p></div>`

      $('div.answerbox').html(answer);
      $('div.answerbox ul').addClass('bullets');
      $('div.answerbox').fadeIn(200);

      $('.qas li.active').removeClass('active');
      $('.qas li.notactive').removeClass('notactive');

      $(this).parent().addClass('active');
      $('.qas li:not(.active)').addClass('notactive');
      $('body').addClass('aopen');

    });
    $(document).on('click', '.qas a', function(e){  e.preventDefault();  });


    // Close Button
    $(document).on('click', '.btn-goemail, .btn-close', function(e){
      $('div.answerbox').fadeOut(200);
      $('body').removeClass('aopen');
    });

  }
};